import React from 'react';
import { CardSummaryBoxHSP } from '@/components/CardSummaryBox/CardSummaryBoxHSP';
import SectionTitle from '@/components/Typography/SectionTitle';

export interface RaportHSPSummaryData {
  overallStatus: 'success' | 'warning' | 'danger';
  totalChecks: number;
  foundIssues: number;
  clearedChecks: number;
  recommendations: string[];
  damageCount?: number;
  lastMileage?: string;
  lastMileageDate?: string;
}

export interface RaportHSPSummaryProps {
  data: RaportHSPSummaryData;
}

export const RaportHSPSummary: React.FC<RaportHSPSummaryProps> = ({ data }) => {
  return (
    <div className="-mt-[350px] w-full lg:-mt-[400px]">
      <div className="b-7 relative flex flex-col items-start justify-start gap-2.5 pb-[16px] pt-[30px] md:pb-[65px] lg:ml-[-48px]">
        <SectionTitle
          title="Kluczowe wskaźniki"
          description="Raport w pigułce - poznaj status pojazdu jednym rzutem oka."
          icon="paper"
          bgWhite={false}
        />
      </div>
      {/* Kluczowe wskaźniki */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <CardSummaryBoxHSP
          title="Ostrzeżenia"
          variant={data.foundIssues > 0 ? 'warning' : 'default'}
          icon={'warning'}
          value={data.foundIssues.toString()}
          description="Liczba wykrytych ostrzeżeń"
        />
        <CardSummaryBoxHSP
          title="Ostatni przebieg"
          variant="danger"
          label="Podejrzanie cofniecie licznika"
          icon={'speedometer'}
          value="85 000 km"
          description="Ostatni znany przebieg wraz z datą odczytu"
        />

        <CardSummaryBoxHSP
          title="Status prawny"
          variant="default"
          icon={'libra'}
          value={'Wymaga weryfikacji'}
          description="Status prawny pojazdu"
          iconStatus={true}
          link={<a href="/status-prawny">Sprawdź</a>}
        />
        <CardSummaryBoxHSP
          title="Liczba szkód"
          icon={'car-accident'}
          value={data.damageCount?.toString() || '0'}
          description="Liczba odnotowanych szkód i wartość największej naprawy"
        />
      </div>
    </div>
  );
};
